import axios from "axios";
import { setDefaultSessionTokenHeader } from "../../componentes-padrao/AxiosConfig";
import { scheduleAccessTokenRefresh } from "../../utils/jwt";
import { configureSession } from "../../utils/session";

export const api = axios.create({
    baseURL: process.env.API_URL,
});

api.interceptors.response.use(
    (response) => {
        const newAccessToken: string = response.data ? response.data["access_token"] : null;
        const newRefreshToken: string = response.data ? response.data["refresh_token"] : null;

        if (newAccessToken) {
            configureSession(newAccessToken, newRefreshToken);

            setDefaultSessionTokenHeader(newAccessToken, newRefreshToken);

            scheduleAccessTokenRefresh(newAccessToken, newRefreshToken);
        }

        return response;
    },
    async (error) => {
        if (error.response) {
            if (error.response.status === 401) {
                window.location.reload();
            }
        }
        return Promise.reject(error);
    },
);

export const oldApi = axios.create({
    baseURL: process.env.OLD_API_URL,
});

export const reportsApi = axios.create({
    baseURL: process.env.API_REPORTS_URL,
});

export const analyticsApi = axios.create({
    baseURL: process.env.API_LOGAE_ANALYTICS_URL,
});
